import { useEffect, useState } from "react";

import { GetRequest } from "./FetchRequest";
import { FetchResponse, LoadingResponse, ResponseState } from "./FetchResponse";
import useFetch from "./useFetch";

const LOADING_RESPONSE: LoadingResponse = {
	state: ResponseState.LOADING
};

export default function useGet<T>(request: GetRequest<T>) {
	const { call } = useFetch();

	const [response, setResponse] =
		useState<FetchResponse<T>>(LOADING_RESPONSE);

	useEffect((): void => {
		refresh();
	}, []);

	function refresh(): void {
		setResponse(LOADING_RESPONSE);

		call(request)
			.then(data =>
				setResponse({
					state: ResponseState.SUCCESS,
					data
				})
			)
			.catch(error =>
				setResponse({
					state: ResponseState.ERROR,
					error: error.message
				})
			);
	}

	return { response, refresh };
}
